import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const CREATE_OWN_WORKSPACE_BIDDER: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation createOwnWorkspaceBidder($input: CreateOwnWorkspaceBidderInput!) {
    result: createOwnWorkspaceBidder(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
